export default {
    path: '/redirect',
    name: 'redirect',
    component: () => import(`./index.vue`),
    meta: {
        // skip_check_token: true,
    },
};
